import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { TimeoutModalHOC } from '../auth';
var title = 'Still there?';
var message = 'We have not heard from you in awhile.  Would you like to remain logged in?';
export var testClassName = function testClassName(name) {
  return "Timeout-Modal-".concat(name);
};
export var DefiTimeoutModal = function DefiTimeoutModal(_ref) {
  var open = _ref.open,
      stay = _ref.stay,
      clock = _ref.clock,
      handleLogout = _ref.handleLogout;
  return React.createElement(Dialog, {
    open: open,
    onClose: stay,
    "data-testid": testClassName('Dialog')
  }, React.createElement(DialogTitle, null, title), React.createElement(DialogContent, null, React.createElement(DialogContentText, null, message)), React.createElement(DialogActions, null, React.createElement(Button, {
    color: "primary",
    onClick: stay,
    className: testClassName('Stay_Button')
  }, "Stay (".concat(clock, ")")), React.createElement(Button, {
    onClick: handleLogout,
    color: "primary",
    className: testClassName('Logout_Button')
  }, "Log Out")));
};
export default TimeoutModalHOC(DefiTimeoutModal);